import React, { useState, useEffect } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import { reset } from "../../../features/Registration/registrationSlice";
import { EntriesPerPage, Search, TableFetch } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import swal from "sweetalert";
import moment from "moment";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import FilterListIcon from "@mui/icons-material/FilterList";
import XLoader from "../../../components/XLoader";
import SendOfferModal from "../../../components/ModalComponents/SendOfferModal";
import DropOutModal from "../../../components/ModalComponents/DropOutModal";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { getallapplicant } from "../../../features/Applicant/applicantSlice";
import { FaFilePdf, FaFileCsv, FaFileImage, FaFile } from "react-icons/fa";
import PdfViewer from "../../../components/PdfViewer";
import ImageLightbox from "../../../components/ImageLightbox";
import StatusButtons from "../../../components/StatusButtons";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";
import SendOfferDrawerComponent from "../../Applicants/ApplicantDrawerComponent/SendOfferDrawerComponent";



const HistoryInterviewTable = ({
  pageHeader,
  headerTitles,
  setResetID
}: any) => {

  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });


  const dispatch = useAppDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
   const [selectedIds, setSelectedIds] = useState<string[]>([]); // State to hold selected IDs
    const [selectedItems, setSelectedItems] = useState<any[]>([]); // State to hold selected items
    const handleCheckboxChange = (itemId: string, item: any) => {
      setIsDrawerOpen(true);
      // Check if the item's ID is already selected
      if (selectedIds.includes(itemId)) {
        // Remove the ID from the selectedIds array
        setSelectedIds(selectedIds.filter((id) => id !== itemId));
        setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((i) => i.id !== itemId));
      } else {
        // Add the ID to the selectedIds array
        setSelectedIds([...selectedIds, itemId]);
        setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
      }
    };

  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess ||
      EditapplicantionisSuccess ||
      sendForTranningisSuccess ||
      updateTranningisSuccess
    ) {
      const input = { interviewStatus: "COMPLETED" };
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, dispatch, UpdateOfferisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, sendForTranningisSuccess, updateTranningisSuccess]);

   

  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const openModal = (fileUrl, fileType, file) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };


  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };

  useEffect(() => {
    const input = { interviewStatus: "COMPLETED" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
   }; 


  // @ts-ignore 
  const filteredCandidates = data?.data?.filter(candidate => candidate?.applicationStatus === "INTERVIEW");



  useEffect(() => {
    const result = filteredCandidates?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchItem]);



  const [displayData, setDisplayData] = useState([]);


  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <Search
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              placeholder={pageHeader}
            />
            <div>
              <EntriesPerPage
                data={datas}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>
            <span className="table-header--icons">
              <FilterListIcon />
            </span>
          </div>
        </header>

        {isLoading && <XLoader isLoading={isLoading} />}

        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td
                    className="table-datacell datatype-string headerTitles"
                    key={i}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoading ? (
                <TableFetch colSpan={12} />
              ) : displayData?.length === undefined ||
                displayData?.length === 0 ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((item: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                      <tr className="data-table-row" key={i}>
  <td>
   
      <div className="md-checkbox">
        <input
          id={`completed-${i}`}
          type="checkbox"
          checked={selectedIds?.includes(item?.id)}
          onChange={() => handleCheckboxChange(item?.id, item)}
        />
        <label htmlFor={`completed-${i}`}></label>
      </div>
    
  </td>
</tr>

                    <td className="table-datacell datatype-string">
                      <div className="dropdown">
                        <button className="dropbtn">
                          <MoreHorizIcon />
                        </button>
                        <div className="dropdown-content">

                          <div>
                            <SendOfferModal
                              title="Send Offer"
                              nametitle={item?.title}
                              name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                              id={item?.id}
                              applicationId={item?.ScreeningLog?.applicationId}
                              recruiterID={item?.ScreeningLog?.recruiterID}
                            />
                          </div>

                          <a>
                            {item?.EvaluatingLog?.evaluatingStatus === "PENDING" ? (
                              <div>Dropout</div>
                            ) : (
                              <DropOutModal
                                title="Dropout"
                                id={item?.id}
                                name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                              />
                            )}
                          </a>
                          {/* <a>
                            {item?.EvaluatingLog?.evaluatingStatus === "PENDING" ? (
                              <div>Hire</div>
                            ) : (
                              <HireModal
                                title="Hire"
                                id={item?.id}
                                name={`${!item?.firstName ? "" : item?.firstName} ${!item?.middleName ? "" : item.middleName} ${!item?.LastName ? "" : item?.LastName}`.trim()}
                              />
                            )}
                          </a> */}
                        </div>
                      </div>

                    </td>
                    <td className="table-datacell datatype-string">
                      <StatusButtons item={item} />
                    </td>
                    <td>

                      <div className="dropdown">
                        <Button className={true ? "view-job-profile more-button-disabled" : "view-job-profile update"}>
                          {true ? "Interview Completed" : "Update Interview Status"}
                        </Button>

                      </div>
                    </td>

                    <td className="table-datacell datatype-numeric toggle">
                      {item?.firstName} {item?.middleName} {item?.LastName}
                      {pageHeader.includes("History")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.gender}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      <Link
                        to={`/viewapplicants/${item?.id}`}
                        className="applicant-btn"
                      >
                        <Button className="view-job-profile">View</Button>
                      </Link>
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.verificationID
                        ? (
                          <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item?.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item?.verificationID,);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                        )
                        : <div className="table-datacell-flex">
                            <span>
                              No ID
                             </span>
                             <ReplaceID id={item?.id} setResetID={setResetID} />
                          </div>
                      }
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.createdAt).format("DD-MM-YYYY")}
                    </td>
                    <td className="table-datacell datatype-string">
                      {moment(item?.updatedAt).format("DD-MM-YYYY")}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {item?.email}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.phoneNumber}
                    </td>

                    <td className="table-datacell datatype-string">
                      {item?.totalWorkExperience}
                    </td>
                    <td className="table-datacell datatype-string">
                      {item?.relevantWorkExperience}
                    </td>
                    <td className="table-datacell datatype-string">
                      <EditApplicant name={item} id={item?.id} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isPDF ? (
            <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
          ) : (
            <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
          )}
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={datas}
              entriesperpage={entriesperpage}
              Total={"Applicant"}
            />
          </div>
          <SendOfferDrawerComponent 
               isOpen={isDrawerOpen} onClose={toggleDrawer} data={selectedItems} id={selectedIds} />
        </div>
      </section>
    </div>
  );
};

export default HistoryInterviewTable;